import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'use-intl';
import { accountKeys } from '@/lib/queries/account';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { BlockedClient } from './-components/BlockedClient';

const PAGE_SIZE = 100;

export const Route = createFileRoute('/_authed/settings/privacy/blocked/')({
  component: SettingsBlockedPage,
});

function SettingsBlockedPage() {
  const t = useTranslations('Settings');
  const query = useQuery({
    ...accountKeys.blockedMembers({ pageSize: PAGE_SIZE }),
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        eyebrow={t('blocked.eyebrow')}
        title={t('blocked.errorTitle')}
        message={t('blocked.loadError')}
        back={{ label: t('blocked.eyebrow'), href: '/settings/privacy' }}
      />
    );
  }
  if (query.isLoading) return null;
  return <BlockedClient pageSize={PAGE_SIZE} />;
}
